/**
 * Slider de preț pentru filtrele de colecție.
 *
 * Horizon randează doar două câmpuri numerice pentru interval; designul DXD are
 * și un slider. Îl adăugăm ca îmbunătățire progresivă: fără JS, câmpurile rămân
 * complet funcționale.
 *
 * Atenție la format: tema scrie limitele localizat („189,90”), deci valorile
 * se normalizează înainte de a deveni numere.
 */
const SLIDER_CLASS = 'dxd-price-slider';

/** „1.234,50” sau „1,234.50” → 1234.5 */
function parseLocalized(raw) {
  if (raw == null) return NaN;
  const text = String(raw).trim().replace(/\s/g, '');
  if (!text) return NaN;

  const lastComma = text.lastIndexOf(',');
  const lastDot = text.lastIndexOf('.');
  let normalized = text;

  if (lastComma > -1 && lastDot > -1) {
    // Separatorul zecimal este cel care apare ultimul.
    normalized = lastComma > lastDot ? text.replace(/\./g, '').replace(',', '.') : text.replace(/,/g, '');
  } else if (lastComma > -1) {
    normalized = text.replace(',', '.');
  }

  return Number(normalized);
}

function decorate(maxInput) {
  const field = maxInput.closest('.price-facet, .facets__panel, fieldset, form') || maxInput.parentElement;
  if (!field || field.querySelector('.' + SLIDER_CLASS)) return;

  const max = parseLocalized(maxInput.dataset.max ?? maxInput.getAttribute('max'));
  if (!Number.isFinite(max) || max <= 0) return;

  const min = parseLocalized(maxInput.dataset.min) || 0;
  const current = parseLocalized(maxInput.value);

  const slider = document.createElement('input');
  slider.type = 'range';
  slider.className = SLIDER_CLASS;
  slider.min = String(Math.floor(min));
  slider.max = String(Math.ceil(max));
  slider.step = '1';
  slider.value = String(Number.isFinite(current) ? current : Math.ceil(max));
  slider.setAttribute('aria-label', maxInput.getAttribute('aria-label') || 'Preț maxim');

  slider.addEventListener('input', () => {
    maxInput.value = slider.value;
    maxInput.dispatchEvent(new Event('input', { bubbles: true }));
  });

  slider.addEventListener('change', () => {
    maxInput.value = slider.value;
    maxInput.dispatchEvent(new Event('change', { bubbles: true }));
  });

  maxInput.addEventListener('input', () => {
    const value = parseLocalized(maxInput.value);
    if (Number.isFinite(value)) slider.value = String(value);
  });

  field.appendChild(slider);
}

function scan() {
  document.querySelectorAll('[ref="maxInput"]').forEach(decorate);
}

scan();
document.addEventListener('DOMContentLoaded', scan);

// Filtrele se re-randează prin Section Rendering API la fiecare schimbare.
new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
